export const getHtmlToPdfmake = async () => {
    let htmlToPdfmake = await import("html-to-pdfmake");
    return htmlToPdfmake
}

export default getHtmlToPdfmake;